import { trackEventFromState } from '@eb/site-analytics';

import { parseFormPostData } from '../api/utils';
import { socialLogIn as socialLogInApi } from '../api';

import {
    GA_AUTH_CATEGORY,
    GA_APPLE_LOGIN_ACCOUNT_CREATED,
    LOOKUP_SOCIAL_USER_EXISTENT,
} from '../constants';

import { GA_APPLE } from '../constants/analytics';

import { trackLoginSuccessful, trackLoginSuccessOneStep } from './gaTracking';

import { getSocialLogInFormData } from './utils';

import { handleLoginSuccess } from './social';

import { lookupUser } from './lookup';

import {
    handleOnError,
    addSocialAuthenticationDataAction,
    setAccountExistent,
} from './auth';

export const handleAppleLoginAttempt = ({
    socialProvider,
    data,
    getState,
    dispatch,
}) => {
    const state = getState();
    const {
        authentication: {
            featureFlags: { launchSignInWithAppleAsPopup },
        },
    } = state;

    if (launchSignInWithAppleAsPopup) {
        const _data = getSocialLoginApiData({
            launchSignInWithAppleAsPopup,
            socialProvider,
            data,
        });
        const { email, sub } = data;

        dispatch(
            addSocialAuthenticationDataAction({
                socialAuthenticationData: { [socialProvider]: _data },
            }),
        );

        return dispatch(
            lookupUser({ email: email, socialProvider, sub }),
        ).catch(({ message }) => {
            if (message === LOOKUP_SOCIAL_USER_EXISTENT) {
                return handleAppleSocialLogin({
                    data: _data,
                    getState,
                    dispatch,
                    socialProvider,
                });
            }
        });
    } else {
        handleAppleSocialLogin({
            data,
            getState,
            dispatch,
            socialProvider,
        });
    }
};

export const handleAppleSocialLogin = ({
    data,
    getState,
    dispatch,
    socialProvider,
}) => {
    const state = getState();

    return socialLogInApi(
        parseFormPostData(getSocialLogInFormData(data, getState)),
    )
        .then((response) => {
            trackAppleLoginSuccess(state, response);

            return handleAppleLoginSuccess({
                state,
                data,
                response,
                dispatch,
            });
        })
        .catch(handleOnError(dispatch, state, data));
};

const trackAppleLoginSuccess = (state, response, actionCategory) => {
    if (response['new_user']) {
        trackEventFromState(state, {
            action: GA_APPLE_LOGIN_ACCOUNT_CREATED,
            category: actionCategory ? actionCategory : GA_AUTH_CATEGORY,
        });
        trackLoginSuccessful({
            sourceProvider: GA_APPLE,
            state,
        });
    } else {
        trackLoginSuccessOneStep({
            sourceProvider: GA_APPLE,
            state,
            gaCategory: actionCategory,
        });
    }
};

const handleAppleLoginSuccess = ({ state, response, data, dispatch }) => {
    // Fresh account coming from the social provider
    // Scenario: appleFreshAccount, appleFreshAccount_AddingExistingAccount, appleFreshAccount_AddingSoftAccount
    dispatch(setAccountExistent(data.email));
    dispatch(
        addSocialAuthenticationDataAction({
            socialAuthenticationData: { apple: data },
        }),
    );

    handleLoginSuccess({ state, response, dispatch });
};

/**
 * Returns a useful data structure for the socialLogin api
 * @param {bool} launchSignInWithAppleAsPopup
 * @param {string} socialProvider
 * @param {object} data
 */
const getSocialLoginApiData = ({
    launchSignInWithAppleAsPopup,
    socialProvider,
    data = {},
}) => {
    let _data = data;

    if (launchSignInWithAppleAsPopup) {
        // On the new flow, data is the raw response we get from apple. On the old, it has already been parsed.
        const {
            accessToken,
            skipCreation,
            email,
            expirationTimestamp,
            sub,
        } = data;

        _data = {
            expirationTimestamp,
            email,
            accessToken,
            sourceProvider: socialProvider,
            skipCreation,
            sub,
        };
    }

    return _data;
};
